/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USERS_WITH_BOXES = gql`
  query GetReferals($options: GetManyOptions, $filters: ReferalFilterInput) {
    getReferals(options: $options, filters: $filters) {
      count
      skip
      limit
      content {
        id
        user {
          vuid
          firstName
          lastName
          fullName
          email
          gender
          id
          role {
            name
            state
            uuid
          }
          accountStatus
          emailVerified
          suspended
        }
        createdAt
        updatedAt
        inviteNote
        presentation {
          id
          name
        }
        sections {
          id
          name
        }
        partition
        invitedBy {
          email
          firstName
          lastName
          fullName
        }
        sectionOptType
        box {
          paymentStats
          totalAmount
          totalAmountInUSD
          boxStatus
          discount {
            discountAmount
          }
          amountPaid
          amountPaidInUSD
          note
        }
        inviteStatus
        expiresOn
        discountCode {
          discountId
          discountCode
          status
        }
        discountCodeBox {
          discountCode
          discountId
          status
        }
        inviteType
      }
    }
  }
`;

export const GET_USERS_WITH_BOXES_COMMITTEE = gql`
  query GetReferals($options: GetManyOptions, $filters: ReferalFilterInput) {
    getReferals(options: $options, filters: $filters) {
      count
      skip
      limit
      content {
        id
        user {
          vuid
          firstName
          lastName
          fullName
          email
          gender
          id
          role {
            name
            state
            uuid
          }
          accountStatus
          emailVerified
          suspended
        }
        createdAt
        updatedAt
        inviteNote
        presentation {
          id
          name
        }
        sections {
          id
          name
        }
        partition
        invitedBy {
          email
          firstName
          lastName
          fullName
        }
        sectionOptType
        box {
          paymentStats
          boxStatus
          note
        }
        inviteStatus
        expiresOn
        discountCode {
          discountId
          discountCode
          status
        }
        discountCodeBox {
          discountCode
          discountId
          status
        }
        inviteType
      }
    }
  }
`;
